import { createModel } from 'xstate/lib/model';

import baseEvents from 'common/bento/config/baseEvents';
import { CompanyContextType } from 'common/hooks/useCompanyContext/types';

import { ShineStartVerificationModuleDataQuery } from '../graphql/queries/shineStartVerificationModuleData.gql';

export interface ShineStartVerificationModuleData {
  companyContext: CompanyContextType;
  data: ShineStartVerificationModuleDataQuery & {
    viewer: {
      company: {
        shineStart: NonNullable<
          ShineStartVerificationModuleDataQuery['viewer']['company']['shineStart']
        >;
      };
    };
  };
}

const initialContext = {
  getModuleData: (() => {
    throw new Error('NOT_IMPLEMENTED');
  }) as () => ShineStartVerificationModuleData,
  selectedDocumentId: null as string | null,
};

export type Context = typeof initialContext;

const model = createModel(
  initialContext,

  {
    events: {
      ...baseEvents,
      SELECT_DOCUMENT: (documentId: string) => ({ documentId }),
    },
  },
);

export default model;

export type Model = typeof model;
